import { type PostContentBlocksType } from "./postUtils";
export type blockSpecSocial = {
  url?: string;
  service?: string;
};
export type BlockData = {
  service?: string;
  url?: string;
  mediaPosition?: string;
  layout?: {
    type?: string;
    justifyContent: "center" | "left" | "right";
    flexWrap?: string;
    orientation?: string;
    verticalAlignment?: string;
  };
  style?: {
    elements?: {
      link?: {
        color?: {
          text?: string;
        };
      };
    };
    spacing?: {
      padding?: {
        top?: string;
        bottom?: string;
        left?: string;
        right?: string;
      };
      margin?: {
        top?: string;
        bottom?: string;
        left?: string;
        right?: string;
      };
      blockGap?: {
        top?: string;
        left?: string;
      };
    };
  };
};

const fromStringToCSSValue = (styleValue: string) => {
  if (styleValue?.startsWith("var")) {
    const variable = styleValue.replace("var:", "").split("|").join("--");
    return `var(--wp--${variable})`;
  }
};

const handleGapStyle = (
  block: PostContentBlocksType,
  indexBlock: number,
  indexLivel: number,
  indexArticle: number
): string => {
  const blockGap = block?.attrs?.style?.spacing?.blockGap;
  if (!blockGap) return "";

  if (blockGap.left != undefined || blockGap.left != undefined) {
    return `
    .post_content .wp-block-${indexArticle}-${indexBlock}-${indexLivel} { 
      --wp--style--unstable-gallery-gap: ${fromStringToCSSValue(blockGap.left)};

      gap: ${blockGap.top ? fromStringToCSSValue(blockGap.top) : ""} ${
      blockGap.left ? fromStringToCSSValue(blockGap.left) : ""
    };
    }`;
  } else {
    return `
    .post_content .wp-block-${indexArticle}-${indexBlock}-${indexLivel} { 
      gap: ${fromStringToCSSValue(blockGap as string)};
    }`;
  }
};

const handlePaddingStyle = (
  block: PostContentBlocksType,
  indexBlock: number,
  indexLivel: number,
  indexArticle: number
): string => {
  const blockGap = block?.attrs?.style?.spacing?.padding;
  if (!blockGap) return "";
  return `
    .post_content .wp-block-${indexArticle}-${indexBlock}-${indexLivel} { 
      ${
        blockGap.top ? `padding-top:${fromStringToCSSValue(blockGap.top)};` : ``
      }
      ${
        blockGap.bottom
          ? `padding-bottom:${fromStringToCSSValue(blockGap.bottom)};`
          : ``
      }
      ${
        blockGap.right
          ? `padding-right:${fromStringToCSSValue(blockGap.right)};`
          : ``
      }
      ${
        blockGap.left
          ? `padding-left:${fromStringToCSSValue(blockGap.left)};`
          : ``
      }
    }`;
};

const handleLayoutStyle = (
  block: PostContentBlocksType,
  indexBlock: number,
  indexLivel: number,
  indexArticle: number
): string => {
  const layoutJustify = block?.attrs?.layout?.justifyContent;
  const layoutType = block?.attrs?.layout?.type;
  const layoutFlexWrap = block?.attrs?.layout?.flexWrap;
  const layoutOrientation = block?.attrs?.layout?.orientation;
  const verticalAlignment =
    block?.attrs?.layout?.verticalAlignment == "bottom"
      ? "flex-end"
      : block?.attrs?.layout?.verticalAlignment == "top"
      ? "flex-start "
      : block?.attrs?.layout?.verticalAlignment == "center"
      ? "center"
      : layoutOrientation == "vertical"
      ? "flex-start "
      : "";
  if (!layoutJustify && !layoutType && !layoutFlexWrap) return "";

  return `
      .post_content .wp-block-${indexArticle}-${indexBlock}-${indexLivel} {
        ${layoutType ? `display: ${layoutType};` : ``}
        ${layoutJustify ? `justify-content: ${layoutJustify};` : ``}
        ${layoutFlexWrap ? `flex-wrap: ${layoutFlexWrap};` : ``}
        ${
          layoutOrientation
            ? `flex-direction: ${
                layoutOrientation == "vertical" ? "column" : "row"
              };`
            : ``
        }
        ${verticalAlignment ? `align-items: ${verticalAlignment};` : ``}
      }
    `;
};

const handleLinkStyle = (
  block: PostContentBlocksType,
  indexBlock: number,
  indexLivel: number,
  indexArticle: number
): string => {
  const linkColorStyle = block?.attrs?.style?.elements?.link?.color;

  if (!linkColorStyle) return "";

  return `
    .post_content .wp-block-${indexArticle}-${indexBlock}-${indexLivel}  > * a {
      color: ${fromStringToCSSValue(linkColorStyle.text)}
    }
  `;
};

export const getStyleFromBlocks = (
  blocks: PostContentBlocksType[],
  indexBlock: number,
  indexLivel: number,
  indexArticle: number
): string => {
  const styleBlocks = blocks
    .map((block) => {
      return [
        handleLinkStyle,
        handleLayoutStyle,
        handleGapStyle,
        handlePaddingStyle,
      ].map((fun) => fun(block, indexBlock, indexLivel, indexArticle)).join(`
      `);
    })
    .join(" ");

  return styleBlocks.match(/[a-zA-Z-0-9\-_]/g) ? styleBlocks : null;
};

export const extractFirstBlock = (postContent: string): string => {
  const blocks =
    postContent.match(/<!-- wp:.* -->(.|\n)*?<!-- \/wp:.* -->/gm) || [];

  if (!blocks) return null;

  return blocks[0] || null;
};
